module.exports = __webpack_public_path__ + "img/UZ.f044cac9.svg";